/* eslint-disable no-param-reassign */

import {
  FETCH_STATE_ERROR,
  FETCH_STATE_NONE,
  FETCH_STATE_PENDING,
  FETCH_STATE_SUCCESS,
} from '~/config/constants';

const defaultState = {
  collection: [],
  previewId: null,
  collectionFetchState: FETCH_STATE_NONE,
  showId: null,
};

export default {
  namespaced: true,
  state: { ...defaultState },
  mutations: {
    getCollectionSuccess(state, action) {
      Object.assign(state, action.payload.data);
      Object.assign(state, { previewId: action.payload.config.params.preview_id });

      state.collectionFetchState = FETCH_STATE_SUCCESS;
    },
    getCollectionError(state) {
      state.collectionFetchState = FETCH_STATE_ERROR;
    },
    getCollectionStart(state) {
      state.collectionFetchState = FETCH_STATE_PENDING;
    },
    showAppUpdate(state, id) {
      state.showId = id;
    },
  },
  actions: {
    getCollection({ commit, state, rootGetters }, previewId = null) {
      if (previewId === null && state.collectionFetchState !== FETCH_STATE_NONE) {
        return;
      }

      commit(
        'api/fetch',
        {
          url: '/app_updates',
          params: {
            preview_id: previewId,
          },
          method: 'GET',
          headers: rootGetters['auth/getHeaders'],
          onStart: ['appUpdates/getCollectionStart'],
          onSuccess: ['appUpdates/getCollectionSuccess'],
          onError: ['appUpdates/getCollectionError'],
        },
        { root: true },
      );
    },
    showAppUpdate({ commit }, payload) {
      commit('showAppUpdate', payload);
    },
    markAsRead({ commit, rootGetters }, id) {
      commit(
        'api/fetch',
        {
          url: '/app_updates/mark_as_read',
          method: 'POST',
          body: {
            id,
          },
          headers: rootGetters['auth/getHeaders'],
        },
        { root: true },
      );
    },
    markAsView({ commit, rootGetters }, id) {
      commit(
        'api/fetch',
        {
          url: '/app_updates/mark_as_view',
          method: 'POST',
          body: {
            id,
          },
          headers: rootGetters['auth/getHeaders'],
        },
        { root: true },
      );
    },
    markAsClose({ commit, rootGetters }, id) {
      commit(
        'api/fetch',
        {
          url: '/app_updates/mark_as_close',
          method: 'POST',
          body: {
            id,
          },
          headers: rootGetters['auth/getHeaders'],
        },
        { root: true },
      );
    },
    getCollectionSuccess({ commit }, payload) {
      commit('getCollectionSuccess', payload);
    },
    getCollectionError({ commit }, payload) {
      commit('getCollectionError', payload);
    },
  },
  getters: {
    isCollectionLoaded(state) {
      return (
        state.collectionFetchState === FETCH_STATE_SUCCESS
              || state.collectionFetchState === FETCH_STATE_ERROR
      );
    },
    hasCollectionAnyItems(state) {
      return state.collection.length !== 0;
    },
    hasPreviewID(state) {
      return state.previewId !== null;
    },
    fetchedForDashboard(state) {
      return state.previewId === 'all';
    },
  },
};
